import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { MessageService } from "../message.service";

@Injectable({
    providedIn: 'root'
})

export class UserService {

    private userUrl = location.origin + '/api/user/';

    private privateUrl = location.origin + '/api/user/private/';

    private resetPwdUrl = location.origin + '/api/user/resetpassword/';

    private adminUrl = location.origin + '/api/user/admin/';

    private token = localStorage.getItem('token');

    private headers = new HttpHeaders().set('Content-Type', 'application/json');
    httpOptions = this.headers.append('Authorization', `Bearer ${this.token}`);

    constructor(private http: HttpClient, private messageService: MessageService) { }

    getToken() {
        return this.headers.append('Authorization', `Bearer ${localStorage.getItem('token')}`);
    }

    getAllClienteList(): Observable<any> {
        return this.http.get<any>(`${this.userUrl}client/all`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    getHrUserDetailsForCandidatePrivacy(dataJson:any):Observable<any> {
        return this.http.post<any>(`${this.userUrl}client/report/candidate/privacy`, dataJson)
            .pipe(
                tap(() => this.messageService.add('fetched data')),
            );
    }

    getClientDetail(clientId: string): Observable<any> {
        return this.http.get<any>(`${this.userUrl}client/${clientId}`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    updateCost(clientId: string, dataJson:any): Observable<any> {
        return this.http.post<any>(`${this.userUrl}client/cost/${clientId}`, dataJson, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    updateClinetReportDefault(clientId: string, dataJson:any): Observable<any> {
        return this.http.post<any>(`${this.userUrl}client/reportDefault/${clientId}`, dataJson, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    getPersonalDetail(): Observable<any> {
        return this.http.get<any>(`${this.privateUrl}personal/get`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    getCompanyDetail(): Observable<any> {
        return this.http.get<any>(`${this.privateUrl}company/get`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    getContractDetail(): Observable<any> {
        return this.http.get<any>(`${this.privateUrl}contract/get`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }


    saveContractDocument(contractDocument: any): Observable<any> {
        return this.http.post<any>(`${this.privateUrl}contract`, contractDocument, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    savePersonalDetail(personalObj: any): Observable<any> {
        return this.http.post<any>(`${this.privateUrl}personal`, personalObj, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    saveCompanyDetail(companyObj: any): Observable<any> {
        return this.http.post<any>(`${this.privateUrl}company`, companyObj, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    verifyUserByActivationCode(activationCode: string): Observable<any> {
        return this.http.get<any>(`${this.resetPwdUrl}verify/${activationCode}`)
            .pipe(
                tap(() => this.messageService.add('fetched data')),
            );
    }

    updatePassword(dataJson: any): Observable<any> {
        return this.http.post<any>(`${this.resetPwdUrl}update`, dataJson)
            .pipe(
                tap(() => this.messageService.add('fetched data')),
            );
    }

    changePassword(dataJson: any): Observable<any> {
        return this.http.post<any>(`${this.userUrl}changepassword/update`, dataJson, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
            );
    }

    getRoleByUser(id): Observable<any> {
        return this.http.get<any>(`${this.privateUrl}be/role/${id}`, { headers: this.httpOptions });
    }

    getPersonalDetailByUserEmail(userEmail): Observable<any> {
        return this.http.get<any>(`${this.userUrl}personalDetail/${userEmail}`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    adminCheck(): Observable<any> {
        return this.http.get<any>(`${this.userUrl}admin/check`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
            );
    }

    getAdminDetail(): Observable<any> {
        return this.http.get<any>(`${this.adminUrl}get/detail`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
            );
    }

    updateAdminDetail(personalDetail:any): Observable<any> {
        return this.http.post<any>(`${this.adminUrl}update/personal/detail`, personalDetail, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
            );
    }

    changeHrweUserStatus(statusUpdate:any):Observable<any> {
        return this.http.post<any>(`${this.userUrl}update/status`, statusUpdate, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
            );
    }

}